/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpBackend,
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
import { UntilDestroy } from '@ngneat/until-destroy';
import { decryptData } from '../utils/encryption.utils';
import { CourseCustomer } from '@app/models';
import { SCData } from '@app/models/core/SCData';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  private bypassClient = new HttpClient(inject(HttpBackend));

  constructor(private credentialsService: CredentialsService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!/^(http|https):/i.test(request.url)) {
      request = request.clone({
        url: environment.serverUrl + environment.apiVersion + request.url,
      });
    }
    if (this.credentialsService.token) {
      request = request.clone({
        headers: request.headers.append(
          'Authorization',
          'Bearer ' + this.credentialsService.token,
        ),
      });
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const dtr = urlParams.get('dtr');
      if (dtr) {
        const decryptedToken = decryptData(dtr);
        if (decryptedToken) {
          // Get user data using token
          this.getMeData(decryptedToken).subscribe({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            next: (res: SCData<any>) => {
              this.credentialsService.setCredentials(res.data, true);
              request = request.clone({
                headers: request.headers.append(
                  'Authorization',
                  'Bearer ' + this.credentialsService.token,
                ),
              });
            },
          });
        }
      }
    }
    return next.handle(request);
  }

  getMeData(token: string) {
    return <Observable<SCData<CourseCustomer>>>this.bypassClient.get(
      `${environment.serverUrl}${environment.apiVersion}/course-user/me`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  }
}
